import { render, staticRenderFns } from "./GetMoreMini.vue?vue&type=template&id=07b47d86&scoped=true&"
import script from "./GetMoreMini.vue?vue&type=script&lang=js&"
export * from "./GetMoreMini.vue?vue&type=script&lang=js&"
import style0 from "./GetMoreMini.vue?vue&type=style&index=0&id=07b47d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b47d86",
  null
  
)

export default component.exports